import React from 'react';
import PropTypes from 'prop-types';
import { Filters } from '../filters.model';
import { InventoryTypeFilterComponent, VinFilterComponent, MakeFilterComponent, YearFilterComponent, ModelFilterComponent, TrimFilterComponent, StockNumberFilterComponent } from './filter/components.index';
import './vehicleFilters.component.scss';

const VehicleFiltersComponent = props => {
  const filters = props.filters;

  const handleFilterUpdate = (filterId, value) => {
    switch (filterId) {
      case 'inventoryType':
        filters.inventoryType.types = value.filter(x => x !== 'undefined');
        break;
      case 'vin':
        filters.vin = value;
        break;
      case 'stockNumber':
        filters.stockNumber = value;
        break;
      case 'make':
        filters.make.value = value;
        break;
      case 'year':
        filters.year.value = value;
        break;
      case 'model':
        filters.model.value = value;
        break;
      case 'trim':
        filters.trim.value = value;
        break;
      default:
      // nothing to do here
    }

    props.onFilter(filters);
  };

  if (filters === null) return <div />;

  return (
    <div className="vlp-filters">
      <InventoryTypeFilterComponent filter={filters.inventoryType} handleFilterUpdate={handleFilterUpdate} />
      <VinFilterComponent filter={filters.vin} handleFilterUpdate={handleFilterUpdate} />
      <StockNumberFilterComponent filter={filters.stockNumber} handleFilterUpdate={handleFilterUpdate} />
      <MakeFilterComponent filter={filters.make} handleFilterUpdate={handleFilterUpdate} />
      <YearFilterComponent filter={filters.year} handleFilterUpdate={handleFilterUpdate} />
      <ModelFilterComponent filter={filters.model} handleFilterUpdate={handleFilterUpdate} />
      <TrimFilterComponent filter={filters.trim} handleFilterUpdate={handleFilterUpdate} />
    </div>
  );
};

VehicleFiltersComponent.propTypes = {
  filters: PropTypes.instanceOf(Filters),
  onFilter: PropTypes.func.isRequired
};

export default VehicleFiltersComponent;



// WEBPACK FOOTER //
// ./src/components/vehicles/filters/vehicleFilters.component.js